var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindSpeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#206bdd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 25,
    height: 25,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.01,59.42A3.532,3.532,0,0,1,27.7,57.113a.883.883,0,0,1,1.656-.613,1.765,1.765,0,1,0,1.656-2.377H18.649a.883.883,0,1,1,0-1.766H31.01a3.532,3.532,0,0,1,0,7.064Zm6.181-8.829H17.766a.883.883,0,0,1,0-1.766H37.191a1.766,1.766,0,1,0-1.656-2.378.883.883,0,0,1-1.656-.613,3.532,3.532,0,1,1,3.311,4.757Zm-9.712-3.532h-10.6a.883.883,0,1,1,0-1.766h10.6a1.766,1.766,0,1,0-1.656-2.378.883.883,0,0,1-1.656-.613,3.532,3.532,0,1,1,3.311,4.757Z",
    transform: "translate(-12.929 -34.276)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeed);
export default __webpack_public_path__ + "static/media/wind_speed.e10774881dc9da38807072557452ccf5.svg";
export { ForwardRef as ReactComponent };